import { put, select } from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';


export function* initDevicesSaga(action) {
  // console.log('action ::::', action);
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {

    yield put(actions.initDevicesStart());
    var path = '/devices';
    const withPortForwarding = !!action.withPortForwarding
    const bod = {
      rMac: rMac,
      bToken: token,
      sessionToken: sessionToken,
      withPortForwarding,
    };
    try {
      const response = yield axios.post(
        path,
        bod,
        {
          validateStatus: false
        }
      )
      if(response.status === 200) {
        yield put(actions.setDevices(response.data));
        yield put(actions.setDevicesByEquipment(response.data, action.selectedEquipment));
        yield put(actions.setSelectedEquipment(action.selectedEquipment));
      }
      else {
        yield put(actions.fetchDevicesFailed({refresh: action.selectedEquipment ? true : false, errorStatus: response.status}));
      }
    } catch (error) {
      console.error('THERE IS ERR IN DEVICES', error);
      yield put(actions.fetchDevicesFailed({refresh: action.selectedEquipment ? true : false}));

    }


  } else {
    // console.log('NO TOKEN')
  }

}

export function* changeDeviceNameSaga(action) {
  console.log('sagas 46 :::', action);
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/deviceNameChange',
        {
          rMac: rMac,
          bToken: token,
          deviceName: action.deviceName,
          deviceIcon: action.deviceIcon,
          devMac: action.devMac,
          sessionToken: sessionToken
        }
      );
      if (response.data.status === 200) {
        yield put(actions.initDevices({ selectedEquipment: action.selectedEquipment }));
        yield put(actions.initBandwidth());
        yield put(actions.initDeviceGroups());
        yield put(actions.changeDevicesSuccess());
      } else {
        // console.log('CHANGE DEVICE NAME OR ICON ERROR')
        yield put(actions.changeDevicesFailed(action));
      }


    } catch (error) {
      console.error('CHANGE DEVICE NAME OR ICON ERROR', error)
      yield put(actions.changeDevicesFailed(action));
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDevicesFailed(action));

  }

}
export function* changeDeviceIconSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {

    try {
      const response = yield axios.post(
        '/deviceIconChange',
        {
          rMac: rMac,
          bToken: token,
          deviceIcon: action.deviceIcon,
          deviceName: action.deviceName,
          devMac: action.devMac,
          sessionToken: sessionToken
        }
      )

      if (response.data.status === 200) {
        yield put(actions.initDevices({ selectedEquipment: action.selectedEquipment }));
        yield put(actions.initBandwidth());
        yield put(actions.initDeviceGroups());
        yield put(actions.changeDevicesSuccess());
      } else {
        // console.log('CHANGE DEVICE NAME OR ICON ERROR')
        yield put(actions.changeDevicesFailed(action));
      }
    } catch (error) {
      // console.error('CHANGE DEVICE ICON ERROR', error)
      yield put(actions.changeDevicesFailed(action));
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDevicesFailed(action));

  }

}
export function* changeFreezeDeviceSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      // console.log("Check Enable",action)
      const response = yield axios.post(
        '/deviceFreezeChange',
        {
          rMac: rMac,
          bToken: token,
          putDelete: action.putDelete,
          templateID: action.templateID,
          template: action.template,
          devMac: action.deviceMac,
          sessionToken: sessionToken
        }
      )
      if (response.data.status === 200) {

        yield put(actions.initDevices({ selectedEquipment: action.selectedEquipment }));
        yield put(actions.initBandwidth());
        yield put(actions.initDeviceGroups());
        yield put(actions.changeDevicesSuccess());
      } else {
        // console.log('FAILED DEVICES')
        yield put(actions.changeDevicesFailed());
      }

    } catch (error) {
      // console.error('CHANGE FREEZE ERROR', error)
      yield put(actions.changeDevicesFailed(action));
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDevicesFailed(action));

  }

}
export function* changePauseDeviceSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/devicePauseChange',
        {
          rMac: rMac,
          bToken: token,
          enabled: action.enabled,
          devMac: action.deviceMac,
          sessionToken: sessionToken
        }
      )
      if (response.data.status === 200) {
        yield put(actions.initDevices({ selectedEquipment: action.selectedEquipment }));
        yield put(actions.initBandwidth());
        yield put(actions.initDeviceGroups());
        yield put(actions.changeDevicesSuccess());
      } else {
        // console.log('FAILED DEVICES')
        yield put(actions.changeDevicesFailed());
      }

    } catch (error) {
      // console.error('CHANGE PAUSE ERROR', error)
      yield put(actions.changeDevicesFailed(action));
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDevicesFailed(action));

  }

}
export function* deleteDeviceSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/deviceDelete',
        {
          rMac: rMac,
          bToken: token,
          devMac: action.deviceMac,
          sessionToken: sessionToken
        }
      );
      if (response.data.status === 200) {
        yield put(actions.initDevices({ selectedEquipment: action.selectedEquipment }));
        yield put(actions.initBandwidth());
        yield put(actions.initDeviceGroups());
        yield put(actions.changeDevicesSuccess());
      } else {
        // console.log('FAILED DEVICES')
        yield put(actions.changeDevicesFailed());
      }



    } catch (error) {
      // console.error('CHANGE DEVICES ERROR', error)
      yield put(actions.changeDevicesFailed(action));
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDevicesFailed(action));

  }

}
export function* getAdvancedDeviceSaga(action) {
  // console.log('get advanced device start', action.deviceMac)
  yield put(actions.getAdvancedDeviceStart(action.deviceMac));
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/getAdvancedDevice',
        {
          rMac: rMac,
          bToken: token,
          deviceMac: action.deviceMac,
          days: action.days,
          sessionToken: sessionToken
        }
      );

      if (response.data.status === 200) {
        // console.log('get advanced device end', response.data.advancedDevice)

        yield put(actions.setAdvancedDevice(response.data.advancedDevice));
      } else {
        // console.log('GET ADVANCED DEVICE FAILED')
      }


    } catch (error) {
      // console.error('GET ADVANCED DEVICE FAILED', error)
      yield put(actions.changeDevicesFailed(action));
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDevicesFailed(action));

  }

}

export function* getAdvancedDeviceIdsSaga(action) {
  yield put(actions.getAdvancedDeviceStart());

  // console.log('get advanced device ids saga',action)
  const getReduxDevices = state => state.devices.realDevices;
  const foundDevices = yield select(getReduxDevices);

  //yield put(actions.getAdvancedDeviceStart(action.deviceMac));
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const deviceMacs = action.deviceMacs && action.deviceMacs.length ? action.deviceMacs
    : yield foundDevices?.map(d => d.mac)
  if (sessionToken) {
    try {
      // console.log('DEVICE MACS', deviceMacs)
      const response = yield axios.post(
        '/getAdvancedDeviceIds',
        {
          rMac: rMac,
          bToken: token,
          deviceMacs: deviceMacs,
          sessionToken: sessionToken
        }
      );
      // console.log('RESPONSE StatuS',)
      if (response.data.status === 200) {
        // console.log('get advanced device ids end', response.data)

        yield put(actions.setAdvancedDeviceIds(response.data.message));
      } else {
        // console.log('GET ADVANCED DEVICE IDS FAILED', response.data)
      }


    } catch (error) {
      // console.error('ERR GET ADVANCED DEVICE IDS FAILED', error)
      yield put(actions.changeDevicesFailed(action));
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDevicesFailed(action));

  }

}


export function* reportAdidIssueSaga(action) {
  // console.log('reportAdidIssue saga', action)
  //yield put(actions.getAdvancedDeviceStart(action.deviceMac));
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const userId = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      let incorrectProperty = (!action.incorrectProperty || action.incorrectProperty === '') ? 'N/A' : action.incorrectProperty;
      let message = (!action.message || action.message === '') ? 'N/A' : action.message;
      const response = yield axios.post(
        '/reportAdidIssue',
        {
          bToken: token,
          sessionToken: sessionToken,
          rMac: rMac,
          deviceMac: action.deviceMac,
          deviceName: action.deviceName,
          issueType: action.issueType,
          incorrectProperty: incorrectProperty,
          message: message
        }
      );


      if (response.data.status === 200) {
        // console.log('reportAdidIssue end', response.data)

        yield put(actions.reportAdidIssueSuccess());
      } else {
        yield put(actions.reportAdidIssueFailed());
        // console.log('reportAdidIssue FAILED')
      }


    } catch (error) {
      // console.error('reportAdidIssue FAILED', error)
      yield put(actions.reportAdidIssueFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.reportAdidIssueFailed());

  }

}

export function* deleteFreezesOnDeviceSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/deleteFreezesOnDevice',
        {
          rMac: rMac,
          bToken: token,
          devMac: action.deviceMac,
          sessionToken: sessionToken
        }
      );
      if (response.data.status === 200) {
        yield put(actions.initDevices(action));
        yield put(actions.initBandwidth());
        yield put(actions.initDeviceGroups());
        yield put(actions.changeDevicesSuccess());
      } else {
        // console.log('FAILED DEVICES')
        yield put(actions.changeDevicesFailed());
      }



    } catch (error) {
      // console.error('CHANGE DEVICES ERROR', error)
      yield put(actions.changeDevicesFailed(action));
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeDevicesFailed(action));

  }

}






